import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MessageGridRecordDto } from '../../../../_models/messaging/messages/message-grid-record-dto';
import { ExecutionResultDto } from '../../../../_models/execution-result-model';
import { NotificationService } from '../../../../_services/notification.service';
import {
  MessageCopyMoveDetailsDtoAdapter
} from '../../../../_models/messaging/messages/message-copy-move-details-dto-adapter';
import {
  MessageCopyMoveFindReplaceDtoAdapter
} from '../../../../_models/messaging/messages/message-copy-move-find-replace-dto-adapter';
import {
  MessageSearchReplaceDtoAdapter
} from '../../../../_models/messaging/messages/message-search-replace.adapter.dto';
import { MessageService } from '../../../../_services/messaging/messages/message.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../_services/system/localStorage/localStorage.service';

@Component({
  selector: 'app-search-replace',
  templateUrl: './search-replace-modal.component.html',
  styleUrls: ['./search-replace-modal.component.scss']
})
export class SearchReplaceModalComponent implements OnInit {
  title = 'Search and Replace in Message';
  findReplaceFormArray: UntypedFormArray;
  selectedMessages: MessageGridRecordDto[];
  searchReplaceInProgress: boolean;

  constructor(
    private notificationService: NotificationService,
    private messageCopyMoveDetailsDtoAdapter: MessageCopyMoveDetailsDtoAdapter,
    private messageCopyMoveFindReplaceDtoAdapter: MessageCopyMoveFindReplaceDtoAdapter,
    private messageSearchReplaceDtoAdapter: MessageSearchReplaceDtoAdapter,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<SearchReplaceModalComponent>,
    private localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) private data
  ) { }

  ngOnInit(): void {
    this.selectedMessages = this.data.selectedMessages;
  }

  setArrayValue(data: UntypedFormArray): void {
    this.findReplaceFormArray = data;
  }

  private sanitizeReplaceWithInput(value: string): string {
    if (value == null) {
      return value;
    }
    return value.replace(/\t/g, '');
  }

  private sanitizeReplaceWithBeforeSave(): void {
    (this.findReplaceFormArray as UntypedFormArray).controls.forEach((message: UntypedFormGroup) => {
      const replaceControl = message.get('replace');
      const replaceValue = this.sanitizeReplaceWithInput(replaceControl.value);
      if (replaceValue !== replaceControl.value) {
        replaceControl.setValue(replaceValue);
      }
    });
  }

  searchReplace(): void  {
    if (!this.findReplaceFormArray?.length) {
      this.notificationService.showError('Please add at least one Search for / Replace with row.');
      return;
    }

    this.sanitizeReplaceWithBeforeSave();

    let clientId = this.localStorageService.getCurrentClientId;
    const messageFindReplace = [];
    let validateLength = true;
    (this.findReplaceFormArray as UntypedFormArray).controls.forEach((message: UntypedFormGroup) => {
      const findValue = message.get('find').value;
      const replaceValue = message.get('replace').value;

      if (findValue.length < 2) {
        this.notificationService.showError('Please enter more than one letter to search for.');
        validateLength = false;
      }

      messageFindReplace.push({
        Find: findValue,
        Replace: replaceValue
      });
    });

    if (!validateLength) { return; }

    const messageDetails = [];
    this.selectedMessages.forEach((message: MessageGridRecordDto) => {
      messageDetails.push({
        MessageId: message.messageId,
        MessageName: message.messageName,
        MessageType: message.messageTypeEnum
      });
    });

    const messagesToReplace = this.messageSearchReplaceDtoAdapter.adapt({
      Messages: this.messageCopyMoveDetailsDtoAdapter.adaptArray(messageDetails),
      FindReplace: this.messageCopyMoveFindReplaceDtoAdapter.adaptArray(messageFindReplace),
      ClientId: clientId
    });

    this.searchReplaceInProgress = true;
    this.messageService.searchReplaceMessage(messagesToReplace).subscribe((executionResultDto: ExecutionResultDto) => {
      this.notificationService.showSuccess(executionResultDto.message);
      this.searchReplaceInProgress = false;
      this.dialogRef.close(true);
    }, async error => {
      console.log(error);
      this.searchReplaceInProgress = false;
      this.dialogRef.close();
    });
  }
}
